import posthog from 'posthog-js';

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string;
// EU cloud by default — matches Amplitude's EU serverZone (data residency).
const POSTHOG_HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string) || 'https://eu.i.posthog.com';

let initialized = false;

export const initPosthog = () => {
  if (import.meta.env.VITE_ENABLE_POSTHOG !== 'true' || !POSTHOG_KEY) return;

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // Opt into PostHog's current recommended defaults: history-aware pageview
    // capture, pageleave, autocapture, web vitals. Powers Web Analytics + the
    // activation funnel without per-event wiring.
    defaults: '2025-05-24',
    // Users are anonymous (no login). 'always' lets person properties
    // (device_tier, locale, ...) attach to anonymous profiles so they're
    // usable as segmentation dimensions. Session replay is gated by the
    // project setting in PostHog — no client flag needed once enabled there.
    person_profiles: 'always',
  });

  // Expose the instance on window for console/debugging — posthog-js does NOT
  // attach to window when imported as an ES module, so `posthog.reset()` in the
  // devtools console would otherwise throw "posthog is not defined".
  (window as unknown as { posthog?: typeof posthog }).posthog = posthog;

  initialized = true;
};

/** Mirror a custom analytics event to PostHog. No-op until initialized. */
export const capturePosthog = (
  eventType: string,
  eventProperties?: Record<string, unknown>,
): void => {
  if (!initialized) return;
  posthog.capture(eventType, eventProperties);
};

/** Mirror identify `$set` user properties to PostHog person properties. */
export const setPosthogPersonProperties = (
  properties: Record<string, unknown>,
): void => {
  if (!initialized) return;
  posthog.setPersonProperties(properties);
};
